import React from 'react';
import cn from '../../utils/cn';

export type ButtonProps = React.ComponentPropsWithoutRef<'button'>;

/**
 * @deprecated This component was migrated from Preact and should not be used or refactored.
 * It does not comply with our current architectural patterns (compound components, proper separation of concerns, etc.).
 * These legacy components will be migrated in due course.
 */
export function Button({ children, className, ...props }: ButtonProps) {
  return (
    <button
      className={cn(
        'rounded-lg bg-brand-500 px-2 py-1 font-semibold text-white shadow-sm hover:bg-brand-600 active:bg-brand-700',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
